export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-50/80 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-base leading-none">瓜</span>
              </div>
              <span className="font-heading text-background-50 font-bold text-lg">吃瓜视频</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              吃瓜视频在线观看——提供51吃瓜、91吃瓜、黑料吃瓜在线观看服务，
              高清流畅播放，即点即看。每日更新最新娱乐八卦、网红爆料、综艺内幕，
              满足你的在线吃瓜观看需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '吃瓜热度榜', href: '#ranking' },
                { label: '专题索引', href: '#index' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新快讯', href: '#updates' },
                { label: '精品推荐', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">热门话题</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '51吃瓜在线观看', href: '#topics' },
                { label: '91吃瓜最新视频', href: '#topics' },
                { label: '黑料吃瓜合集', href: '#topics' },
                { label: '91在线吃瓜', href: '#topics' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 吃瓜视频在线观看 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>51吃瓜在线观看</span>
            <span className="w-px h-3 bg-background-50/20"></span>
            <span>91吃瓜在线观看</span>
            <span className="w-px h-3 bg-background-50/20"></span>
            <span>黑料吃瓜在线观看</span>
          </div>
        </div>
      </div>
    </footer>
  );
}